import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { EntityManagerProvider } from './data/entity-manager-provider';

export interface CanComponentDeactivate {
    canDeactivate: () => boolean | Observable<boolean> | Promise<boolean>;
}

@Injectable()
export class CanDeactivateGuard  {
    canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
        return component.canDeactivate ? component.canDeactivate() : true;
    }
}

@Injectable()
export class PrepareGuard  {
    constructor(public entityManagerProvider: EntityManagerProvider, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        try {
            // return true;
            return this.entityManagerProvider
                .prepare()
                .then(() => true)
                .catch(error => {
                    // if (e.status == 401) {
                    //     //this.authService.redirectUrl = state.url;
                    //     this.router.navigate(['/login']);
                    //     return false;
                    // }

                    console.error('Error connecting to data service: ' + EntityManagerProvider.serviceName, error);
                    return false;
                });
        } catch (error) {
            return false;
        }
    }
}
